import type { enAccount } from '../en/account';

export const idAccount: Record<keyof typeof enAccount, string> = {
  // ---- Tambahan halaman masuk ---------------------------------------------------------
  'auth.signIn.forgot': 'Lupa kata sandi?',
  'auth.signIn.totp': 'Kode autentikator',
  'auth.signIn.totpHint': 'Buka aplikasi autentikator lalu masukkan kode 6 digit.',
  'auth.signIn.error.totpRequired': 'Masukkan kode 6 digit dari aplikasi autentikator Anda.',
  'auth.signIn.error.totpInvalid': 'Kode salah atau sudah kedaluwarsa. Coba kode yang terbaru.',

  // ---- Umum -----------------------------------------------------------------------------
  'account.backToSignIn': 'Kembali ke halaman masuk',
  'account.password': 'Kata sandi',
  'account.passwordHint': 'Minimal 10 karakter.',
  'account.passwordRepeat': 'Ulangi kata sandi',
  'account.error.passwordTooShort': 'Gunakan minimal 10 karakter.',
  'account.error.passwordTooLong': 'Gunakan maksimal 256 karakter.',
  'account.error.passwordMismatch': 'Kedua kata sandi tidak sama.',
  'account.error.nameRequired': 'Masukkan nama Anda.',
  'account.error.termsRequired': 'Setujui ketentuan layanan untuk melanjutkan.',
  'account.error.emailRequired': 'Masukkan alamat email Anda.',
  'account.error.emailInvalid': 'Masukkan alamat email yang valid.',

  // ---- Terima undangan -------------------------------------------------------------------
  'account.invite.title': 'Bergabung dengan {tenant}',
  'account.invite.subtitle':
    'Anda diundang dengan email {email}. Buat kata sandi untuk mulai masuk.',
  'account.invite.name': 'Nama Anda',
  'account.invite.terms': 'Saya menyetujui ketentuan layanan (versi {version}).',
  'account.invite.termsUnversioned': 'Saya menyetujui ketentuan layanan.',
  'account.invite.termsLink': 'Baca ketentuan layanan',
  'account.invite.expires': 'Undangan ini berlaku sampai {date}.',
  'account.invite.submit': 'Gabung dan masuk',
  'account.invite.submitting': 'Memproses…',
  'account.invite.invalidTitle': 'Undangan ini sudah tidak bisa dipakai',
  'account.invite.invalidText':
    'Tautannya sudah kedaluwarsa atau sudah pernah dipakai. Minta orang yang mengundang Anda untuk mengirim undangan baru.',

  // ---- Atur ulang kata sandi --------------------------------------------------------------
  'account.reset.requestTitle': 'Atur ulang kata sandi',
  'account.reset.requestSubtitle':
    'Masukkan email akun Anda. Kami akan mengirim tautan untuk membuat kata sandi baru.',
  'account.reset.email': 'Email',
  'account.reset.requestSubmit': 'Kirim tautan',
  'account.reset.requestSubmitting': 'Mengirim…',
  'account.reset.sentTitle': 'Periksa email Anda',
  'account.reset.sentText':
    'Jika {email} terdaftar, tautan untuk mengatur ulang kata sandi sedang dikirim. Tautan berlaku satu jam.',
  'account.reset.setTitle': 'Buat kata sandi baru',
  'account.reset.setSubtitle':
    'Setelah disimpan, semua perangkat yang sedang masuk ke akun Anda akan keluar otomatis.',
  'account.reset.newPassword': 'Kata sandi baru',
  'account.reset.setSubmit': 'Simpan kata sandi baru',
  'account.reset.setSubmitting': 'Menyimpan…',
  'account.reset.doneTitle': 'Kata sandi sudah diganti',
  'account.reset.doneText': 'Silakan masuk dengan kata sandi baru Anda.',
  'account.reset.invalidTitle': 'Tautan ini sudah tidak bisa dipakai',
  'account.reset.invalidText':
    'Tautan atur ulang berlaku satu jam dan hanya bisa dipakai sekali. Minta tautan baru untuk mencoba lagi.',
  'account.reset.requestNew': 'Minta tautan baru',

  // ---- Verifikasi email -------------------------------------------------------------------
  'account.verify.pendingTitle': 'Mengonfirmasi email Anda…',
  'account.verify.doneTitle': 'Email terkonfirmasi',
  'account.verify.doneText': 'Terima kasih — alamat email Anda sudah terkonfirmasi.',
  'account.verify.invalidTitle': 'Tautan ini sudah tidak bisa dipakai',
  'account.verify.invalidText':
    'Tautannya sudah kedaluwarsa atau sudah pernah dipakai. Kirim tautan konfirmasi baru dari halaman akun Anda.',
  'account.verify.continue': 'Lanjutkan',

  // ---- Ketentuan layanan (sementara)
  'account.terms.title': 'Ketentuan layanan',
  'account.terms.placeholder':
    'Ketentuan layanan akan dipublikasikan di halaman ini. Sementara itu, minta versi terbaru kepada kontak apis Anda.',

  // ---- Back office: akun & keamanan ---------------------------------------------------------
  'bo.nav.account': 'Akun & keamanan',
  'bo.account.title': 'Akun & keamanan',
  'bo.account.subtitle': 'Cara Anda masuk dengan {email}.',
  'bo.account.emailTitle': 'Alamat email',
  'bo.account.emailDesc': 'Dipakai untuk masuk dan untuk mengatur ulang kata sandi.',
  'bo.account.emailVerified': 'Terverifikasi',
  'bo.account.emailUnverified': 'Belum diverifikasi',
  'bo.account.emailSend': 'Kirim tautan konfirmasi',
  'bo.account.emailSending': 'Mengirim…',
  'bo.account.emailSent': 'Tautan konfirmasi dikirim ke {email}.',
  'bo.account.termsAccepted': 'Ketentuan layanan disetujui pada {date} (versi {version}).',
  'bo.account.mfaTitle': 'Verifikasi dua langkah',
  'bo.account.mfaDesc':
    'Setelah kata sandi, minta kode 6 digit dari aplikasi autentikator seperti Google Authenticator atau 1Password.',
  'bo.account.mfaOn': 'Aktif',
  'bo.account.mfaOff': 'Nonaktif',
  'bo.account.mfaNotEligible': 'Tersedia untuk pemilik, administrator, dan manajer.',
  'bo.account.mfaStart': 'Aktifkan verifikasi dua langkah',
  'bo.account.mfaStarting': 'Menyiapkan…',
  'bo.account.mfaScan':
    'Pindai kode QR dengan aplikasi autentikator, atau ketik kunci penyiapan, lalu masukkan kode yang muncul.',
  'bo.account.mfaQrLabel': 'Kode QR untuk aplikasi autentikator',
  'bo.account.mfaKey': 'Kunci penyiapan',
  'bo.account.mfaCode': 'Kode 6 digit',
  'bo.account.mfaCodeInvalid': 'Masukkan 6 digit yang tampil di aplikasi.',
  'bo.account.mfaCodeWrong': 'Kode salah atau sudah kedaluwarsa.',
  'bo.account.mfaConfirm': 'Konfirmasi dan aktifkan',
  'bo.account.mfaConfirming': 'Mengonfirmasi…',
  'bo.account.mfaEnabled': 'Verifikasi dua langkah sudah aktif.',
  'bo.account.mfaDisableHint':
    'Masukkan kode terbaru dari aplikasi untuk menonaktifkan verifikasi dua langkah.',
  'bo.account.mfaDisable': 'Nonaktifkan',
  'bo.account.mfaDisabling': 'Menonaktifkan…',
  'bo.account.mfaDisabled': 'Verifikasi dua langkah sudah dinonaktifkan.',

  // ---- Undangan staf --------------------------------------------------------------------------
  'bo.staff.invite.formDesc':
    'Kosongkan kata sandi untuk mengundang lewat email: mereka membuat kata sandi sendiri.',
  'bo.staff.invite.password': 'Kata sandi awal (opsional)',
  'bo.staff.invite.passwordHint':
    'Kosong = kirim undangan. Jika diisi, minimal 10 karakter. Diabaikan jika email ini sudah punya akun.',
  'bo.staff.invite.submitInvite': 'Kirim undangan',
  'bo.staff.invite.sent': 'Undangan untuk {name} sudah dibuat.',
  'bo.staff.invite.linkTitle': 'Tautan undangan untuk {name}',
  'bo.staff.invite.linkDesc':
    'Pengiriman email belum aktif. Kirim tautan ini sendiri (misalnya lewat WhatsApp). Berlaku 7 hari dan hanya bisa dipakai sekali.',
  'bo.staff.invite.linkLabel': 'Tautan undangan',
  'bo.staff.invite.copy': 'Salin tautan',
  'bo.staff.invite.copied': 'Tautan disalin.',
  'bo.staff.invite.done': 'Selesai',

  // ---- Panduan penyiapan ---------------------------------------------------------------------
  'bo.onboarding.title': 'Siapkan restoran Anda',
  'bo.onboarding.subtitle': 'Enam langkah singkat dari akun kosong sampai pesanan pertama.',
  'bo.onboarding.promptTitle': 'Selesaikan penyiapan {branch}',
  'bo.onboarding.promptDesc':
    'Tambahkan meja dan menu agar kasir dan dapur bisa mulai menerima pesanan.',
  'bo.onboarding.promptAction': 'Lanjutkan penyiapan',
  'bo.onboarding.stepOf': 'Langkah {n} dari {total}',
  'bo.onboarding.stepsLabel': 'Langkah penyiapan',
  'bo.onboarding.statusDone': 'Selesai',
  'bo.onboarding.statusTodo': 'Belum',
  'bo.onboarding.next': 'Berikutnya',
  'bo.onboarding.back': 'Kembali',
  'bo.onboarding.finish': 'Ke dasbor',
  'bo.onboarding.step.branch': 'Data cabang',
  'bo.onboarding.step.tax': 'Pajak & layanan',
  'bo.onboarding.step.tables': 'Area & meja',
  'bo.onboarding.step.menu': 'Menu',
  'bo.onboarding.step.staff': 'Undang staf',
  'bo.onboarding.step.qr': 'Kode QR meja',
  'bo.onboarding.desc.branch':
    'Periksa nama cabang, zona waktu, dan mata uang. Semuanya tampil di struk dan laporan.',
  'bo.onboarding.desc.tax':
    'Pajak restoran (PB1) dan biaya layanan ditambahkan ke setiap tagihan di cabang ini.',
  'bo.onboarding.desc.tables':
    'Buat area restoran dan meja di setiap area. Pesanan dicatat per meja.',
  'bo.onboarding.desc.menu':
    'Tambahkan kategori dan menu beserta harganya. Stasiun dapur menentukan ke mana tiket dicetak.',
  'bo.onboarding.desc.staff':
    'Undang kasir, pelayan, dan tim dapur. Setiap orang masuk dengan akunnya sendiri.',
  'bo.onboarding.desc.qr':
    'Cetak kode QR untuk setiap meja agar tamu bisa membuka menu dan tagihan dari ponselnya.',
  'bo.onboarding.info.branch': '{name} · {code} · {timeZone} · {currency}',
  'bo.onboarding.info.tax': 'Pajak restoran {tax} · biaya layanan {service}',
  'bo.onboarding.info.tables': '{floors} area · {tables} meja',
  'bo.onboarding.info.menu': '{count} menu',
  'bo.onboarding.info.staff': '{count} orang',
  'bo.onboarding.info.qr': '{count} meja siap dicetak',
  'bo.onboarding.menuCsvNote':
    'Impor menu dari file CSV belum tersedia — tambahkan menu lewat halaman Menu.',
  'bo.onboarding.open.branch': 'Buka pengaturan cabang',
  'bo.onboarding.open.tables': 'Buka area & meja',
  'bo.onboarding.open.menu': 'Buka menu',
  'bo.onboarding.open.staff': 'Buka staf',
  'bo.onboarding.open.qr': 'Buka kode QR',
  'bo.onboarding.ownerOnly': 'Hanya pemilik yang dapat menjalankan panduan penyiapan.',
};
